/* ---------- helpers ---------- */
export function guessFamilyFromUrl(url) {
  try {
    const name = url.split("/").pop().split("?")[0];
    const base = name.replace(/\.(woff2|woff|ttf|otf)$/i, "");
    // e.g., "Orbitron-Bold" -> "Orbitron"
    const family = base.split(/[-_]/)[0];
    return capitalizeWords(family.replace(/\s+/g, " "));
  } catch {
    return null;
  }
}

function capitalizeWords(s) {
  return s
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
